export default {
  // 公共
  cancel: 'Hủy bỏ',
  confirm: 'Xác nhận',
  tip: 'Mẹo',
  loading: 'Đang tải...', // 加载中...
  noData: 'Chưa có dữ liệu',
  noMoreData: 'Không còn dữ liệu', // 没有更多数据啦
  refreshText: 'Kéo xuống để làm mới', // 下拉刷新
  refreshActiveText: '释放刷新', // 释放刷新
  refreshingText: 'Đang làm mới...', // 刷新中...
  copySuccess: 'Sao chép thành công',
  copyFailed: 'Sao chéo không thành công',
  noSupportVideoFormat: 'Định dạng video khôngg được hỗ trợ ',
  tokenNoValid: 'Đăng nhập không hợp lệ, vui lòng đăng nhập lại',
  loginAgain: 'Đăng nhập lại',
  logoutSuccess: 'Đăng xuất thành công',
  pleaseLogin: 'Mời đăng nhập', // 请登录
  just: 'Vừa xong', // 刚刚
  minsAgo: ' phút trước', //  例如： 6分钟前
  hoursAgo: ' tiếng trước', // 例如： 6小时前
  daysAgo: ' ngày trước', // 一天前
  cYear: ' Năm ', // 年
  cDay: 'Ngày', // 日
  cMonth: {
    1: 'Tháng 1',
    2: 'Tháng 2',
    3: 'Tháng 3',
    4: 'Tháng 4',
    5: 'Tháng 5',
    6: 'Tháng 6',
    7: 'Tháng 7',
    8: 'Tháng 8',
    9: 'Tháng 9',
    10: 'Tháng 10',
    11: 'Tháng 11',
    12: 'Tháng 12'
  },
  month: ' tháng ',
  // day: 'ngày',
  hour: ' giờ ',
  minute: ' phút ',
  tokenTips: 'Bạn cần đăng kí đăng nhập trước khi có thể hoạt động', // 您需要登录注册后才可进行操作哦！
  chooseStartDate: 'Chọn ngày bắt đầu',
  chooseEndDate: 'Chọn ngày kết thúc',
  dateCustomQuery: 'Tùy chỉnh tìm kiếm ',
  customStartDate: 'Ngày bắt đầu',
  customEndDate: 'Ngày kết thúc',
  dateTips: 'Thời gian bắt đầu không thể lớn hơn thời gian kết thúc',
  noVipTips: 'Bạn chưa phải là VIP!',
  contactCustomer: 'Vui lòng liên hệ với bộ phận chăm sóc khách hàng',
  networkAnomaly: 'Mạng bất thường',
  shareFailByNotAudit: 'Chia sẻ không thành công, đánh giá chưa được thông qua', // 分享失败
  status: 'Trạng thái',

  // 语言
  langChinese: 'Người Trung Quốc', // 中文（繁体）
  langVn: 'Tiếng Việt', // 越南语
  langEnglish: 'Tiếng Anh', // 英语

  // 底部菜单
  footerHome: 'Trang chủ', // 首页
  footerHot: 'Hot', // 热门
  footerUploadVideo: 'Tải lên video ngắn', // 上传短视频
  // footerCs: 'Dịch vụ khách hàng', // 客服
  footerCs: 'Vụ khách', // 客服
  footerMine: 'Tôi', // 我

  // 客服
  customerService: 'Vụ khách', // 客服
  customerRespect: 'Hi, trân trọng', // Hi，尊敬的
  customerTourists: 'Du khách', // 游客
  customerWelcome: 'Chào mừng bạn đến với trung tâm dịch vụ khách hàng', // 欢迎来到客服中心
  customerOnline: 'Dịch vụ khách hàng trực tuyến', // 在线客服
  customer24: 'Đường dây nóng hoạt động 24/7 ', // 7x24小时专线服务贴心至上

  // 首页
  homeChangeNation: 'Chuyển vùng', // 地区切换
  homeEnter: 'Enter', // 进入
  homeLongVideo: 'Video dài', // 影片
  homeShortVideo: 'Video ngắn', // 短视频
  homeNoOpenNet: 'Chức năng này chưa mở！', // 该功能暂未开放！
  homeChooseLang: 'Chọn ngôn ngữ', // 选择语言
  myQrcode: 'Mã QR của tôi', // 我的二维码
  downloadApp: 'Tải ứng dụng', // 下载app
  addFriend: 'Thêm bạn bè', // 添加朋友
  scanMe: 'Quét và theo dõi tôi ngay lập tức', // 扫一扫，立即关注我
  saveQrcode: 'Tiết kiệm', // 保存
  chooseCurrency: 'Chọn tiền tệ', // 选择货币

  // 长电影
  homeLongRecommend: 'Đề xuất hôm nay', // 今日推荐
  homeLongChange: 'Thay đổi hàng loạt', // 换一批

  // 短视频
  homeShort: 'Đề xuất hôm nay', // 今日推荐

  // 发布视频
  homeNovel: 'tiểu thuyết',
  homeRecommend: 'Khuyến nghị',
  homeChoice: 'Category',
  homeRank: 'Xếp hạng',
  homeFree: 'miễn phí',
  homeCompleted: 'Đã hoàn thành',
  homeNotCompleted: 'Serial',
  homeMore: 'Càng nhiều',
  homePublishIntro: 'Viết miêu tả ở đây để nhiều người nhìn thấy hơn～', // 在这里写点描述，让更多人看到～
  homePublishChooseCover: 'Chọn bìa', // 选封面
  homePublishLabel: 'Tag', // 标签
  homePublishBtn: 'Phát hành', // 发布
  homePublishPublic: 'Công khai·Hiển thị với mọi người', // 公开·所有人可见
  homePublishPrivate: 'Riêng tư·Hiển thị chỉ mình tôi', // 私密·仅自己可见
  homePublishing: 'Đang tải lên video ngắn, vui lòng đợi', // 短视频上传中，请稍候
  homePublishFailed: 'Tải video ngắn không thành công, vui lòng tải lại', // 短视频上传失败，请重新上传
  homePublishUploadCover: 'Vui lòng tải ảnh bìa', // 请上传封面图
  homePublishVideoSuccess: 'Tác phẩm được tải lên thành công', // 上传成功提示
  homePrivatePublished: 'Tác phẩm của bạn đã được xuất bản và được nhân viên xem xét! Bạn có thể xem tác phẩm này trên trang chủ cá nhân của mình ', // 私密发布提示
  homePublishCancel: 'Xem xét lại', // 取消发布按钮
  homePublishConfirm: 'OK', // 确认私密发布
  homePublishCancelTips: 'Nếu bạn hủy xuất bản, hệ thống sẽ không giữ các chỉnh sửa hiện tại của bạn', // 取消发布提示
  publishTitle: 'Đăng thông tin',
  clickUploadVideo: 'Nhấp để tải video lên',
  videoSizeMsg: 'Kích thước video không vượt quá 100MB',
  clickUploadCoverImg: 'Nhấp để tải ảnh bìa lên',
  coverImgMsg: 'Ảnh bìa phải khớp với nội dung video',
  whoView: 'Ai có thể xem',
  writeTitle: 'Điền tiêu đề',
  writeTitleMsg: 'Tiêu đề hay sẽ tăng tỷ lệ nhấp vào video',
  writeTitlePlaceholder: 'Điền tiêu đề phù hợp với nội dung video',
  writePrice: 'Đặt giá',
  writePricePlaceholder: 'Nhập giá',
  memberPicker: 'Lựa chọn thành viên',
  videoPreview: 'Xem trước video',
  videoPreviewMsg: 'Giới hạn thời gian xem của người dùng thông thường sau khi phát hành (5–15 giây)',
  videoPreviewPlaceholder: 'Nhập thời gian xem được (5–15 giây)',
  videoLabel: 'Thẻ video',
  videoLabelMsg: 'Chọn thẻ phù hợp nhất với nội dung video, tối đa 4 thẻ',
  allPeople: 'Mọi người',
  memberUsers: 'Người dùng thành viên',
  ordinaryUsers: 'Người dùng thông thường',
  uploadVideoMsg: 'Vui lòng tải video lên',

  // hot
  hotLongVideo: 'Phim hot', // 热门影片
  hotShortVideo: 'Video ngắn hot', // 热门短视频

  // 影片
  hotLong: 'Phim hot', // 热门影片
  hotOverview: 'Tổng quan',
  hotAllTime: 'Mọi lúc',
  hotMonth: 'Nóng nhất tháng này',
  hotWeek: 'Nóng nhất tuần này',
  hotDay: 'Hot Today',
  hotFilmCount: '{0} phim', // chọn đơn vị tiền tệ
  hotFilmEmpty: 'Không có phim nóng đâu ~',

  // 热门短视频
  hotShort: 'Danh sách hot', // 查看热榜
  hotShortHotList: 'Danh sách tìm kiếm hot', // 热搜榜

  // 找回密码
  restPassword: 'Lấy lại mật khẩu', // 找回密码
  restPasswordVerifySent: 'Mã xác minh đã được gửi', // 验证码已发送至
  restPasswordPsdRule: 'Mật khẩu yêu cầu 6-20 chữ số, số thuần túy, chữ cái thuần túy hoặc bất kỳ kết hợp nào', // 密码需要6-20位，纯数字、纯字母，或者任意组合
  restPasswordEnterVerifyCode: 'Vui lòng nhập mã xác minh', // 请输入验证码
  restPasswordEnterNewPsd: 'Vui lòng nhập mật khẩu mới', // 请输入新密码
  restPasswordSelected: 'Vui lòng đánh dấu trước, đăng nhập lại sau khi đồng ý ', // 请先勾选，同意后再进行登录
  restPasswordAgree: 'Đã đọc và đồng ý', // 已阅读并同意
  restPasswordContract: 'Thỏa thuận người dùng', // 用户协议
  restPasswordAnd: 'Và', // 和
  restPasswordPrivate: 'Chính sách quyền riêng tư', // 隐私政策
  restPasswordFinished: 'Hoàn thành', // 完成
  restPasswordRestFailed: 'Đặt lại mật khẩu không thành công', // 重置密码失败

  // 登录
  login: 'Đăng nhập', // 登录
  loginEmail: 'Đăng nhập Email', // 邮箱号登录
  loginPhone: 'Đăng nhập số điện thoại di động', // 手机号登录
  loginEnterPhoneNum: 'Vui lòng nhập số điện thoại di động', // 请输入手机号
  loginEnterEmail: 'Vui lòng nhập email', // 请输入邮箱号
  loginEnterAccount: 'Vui lòng nhập tên người dùng', // 请输入用户名
  loginEnterEmailOrAccount: 'Vui lòng nhập email / tên người dùng', // 请输入邮箱/用户名
  loginEnterPhoneOrAccount: 'Vui lòng nhập số điện thoại di động / tên người dùng', // 请输入手机号/用户名
  loginEnterPsd: 'Vui lòng nhập mật khẩu', // 请输入登录密码
  loginEnterRePsd: 'Nhập lại mật khẩu', // 再次输入输入密码
  // restPasswordSelected: 'Vui lòng đánh dấu trước, đăng nhập lại sau khi đồng ý ', // 请先勾选，同意后再进行登录
  // restPasswordAgree: 'Đã đọc và đồng ý', // 已阅读并同意
  // restPasswordContract: 'Thỏa thuận người dùng', // 用户协议
  // restPasswordAnd: 'Và', // 和
  // restPasswordPrivate
  loginForget: 'Quên mật khẩu? ', // 忘记了？
  loginEmailPsd: 'Đăng nhập email / tên người dùng', // 邮箱密码登录
  loginPhonePsd: 'Đăng nhập mật khẩu điện thoại', // 手机密码登录
  loginCountryArea: 'Chọn một quốc gia', // 选择国家和地区
  loginVn: 'Việt Nam', // 越南
  loginPh: 'Philippines', // 菲律宾
  loginFailed: 'Đăng nhập không thành công', // 登录失败
  loginVerifyCodeSent: 'Đã gửi mã xác minh', // 验证码已发送
  loginVerifyCodeSentFailed: 'Không gửi được mã xác minh', // 验证码发送失败
  loginTitle: 'Đăng nhập để tìm hiểu thêm',
  // 注册
  register: 'Đăng ký',
  registerTitle: 'Đăng nhập để tìm hiểu thêm', // 登录发现更多精彩
  // restPasswordSelected: 'Vui lòng đánh dấu trước, đăng nhập lại sau khi đồng ý ', // 请先勾选，同意后再进行登录
  // restPasswordAgree: 'Đã đọc và đồng ý', // 已阅读并同意
  // restPasswordContract: 'Thỏa thuận người dùng', // 用户协议
  // restPasswordAnd: 'Và', // 和
  // restPasswordPrivate: 'Chính sách quyền riêng tư', // 隐私政策
  registerAnd2: 'Cũng như', // 以及
  registerContract2: 'Thỏa thuận dịch vụ nhà điều hành', // 运营商服务协议
  registerCheckPhone: 'Nhà điều hành sẽ xác minh số điện thoại mà bạn cung cấp', // 运营商将对你提供的手机号进行验证
  registerCheckEmail: 'Nhà điều hành sẽ xác minh Email mà bạn cung cấp', // 运营商将对你提供的邮箱号进行验证
  // loginEnterPhoneNum: 'Vui lòng nhập số điện thoại di động', // 请输入手机号
  // loginEnterEmail: 'Vui lòng nhập Email', // 请输入邮箱号
  registerByPhone: 'Số điện thoại di động chưa đăng ký sẽ tự động được đăng ký sau khi quá trình xác minh được thông qua', // 未注册的手机号验证通过后将自动注册
  registerByEmail: 'Email chưa đăng ký sẽ tự động được đăng ký sau khi quá trình xác minh được thông qua', // 未注册的邮箱号验证通过后将自动注册
  // loginEmail: 'Đăng nhập Email', // 邮箱号登录
  // loginPhone: 'Đăng nhập số điện thoại', // 手机号登录
  registerVerifyLogin: 'Xác thực và đăng nhập', // 验证并登录
  registerPadLogin: 'Đăng nhập mật khẩu', // 密码登录
  // restPasswordEnterVerifyCode: 'Vui lòng nhập mã xác minh', // 请输入验证码
  // restPasswordVerifySent: 'Mã xác minh đã được gửi', // 验证码已发送至
  registerNext: 'Bước tiếp theo', // 下一步
  // login: 'Đăng nhập', // 登录
  registerSetLoginPsd: 'Vui lòng đặt mật khẩu đăng nhập', // 请设置登录密码
  // restPasswordPsdRule: 'Mật khẩu yêu cầu 6-20 chữ số, số thuần túy, chữ cái thuần túy hoặc bất kỳ kết hợp nào', // 密码需要6-20位，纯数字、纯字母，或者任意组合
  registerConfirm: 'Xác nhận', // 确认
  // loginEnterPsd: 'Vui lòng nhập mật khẩu đăng nhập', // 请输入登录密码
  registerContract3: 'Lời khuyên tử tế', // 温馨提示
  registerSafe: 'Chúng tôi sẽ bảo vệ nghiêm ngặt sự an toàn thông tin cá nhân của bạn', // 我们将严格保护你的个人信息安全
  registerAge: 'Bạn trên 18 tuổi phải không', // 请问您是否满18岁
  registerAgreeAndLogin: 'VÂNG', // 是
  registerDisAgree: 'KHÔNG', // 否
  // loginCountryArea: 'Lựa chọn quốc gia và khu vực', // 选择国家和地区
  // loginVn: 'Việt Nam', // 越南
  // loginPh: 'Philippines', // 菲律宾
  // loginVerifyCodeSent: 'Mã xác minh đã được gửi', // 验证码已发送
  // loginVerifyCodeSentFailed: 'Không gửi được mã xác minh', // 验证码发送失败

  // 影片大厅
  // longVideoLobbySearch: 'Vui lòng nhập từ khóa để tìm nguồn', // 请输入关键词查找片源
  longVideoLobbySearch: 'Vui lòng nhập từ khóa', // 请输入关键词查找片源
  longVideoLobbySearchBtn: 'Tìm kiếm', // 搜索
  longVideoLobbyBest: 'Gần đây nhất', // 近期最佳
  longVideoLobbyNewUpdate: 'Cập nhật mới nhất', // 最近更新
  longVideoLobbyMoreView: 'Xem nhiều nhất', // 最多观看
  longVideoLobbyCollect: 'Yêu thích hàng đầu', // 最高收藏
  longVideoLobbyChooseVideo: 'Tuyển chọn phim', // 选片
  longVideoLobbyLabel: 'Nhãn mác', // 标签
  longVideoLobbyMovieNum: '{num} Phim ảnh', // xxx部影片
  longVideoLobbyDefault: 'Sắp xếp mặc định', // 预设排序
  longVideoLobbyHot: 'Phổ biến đầu tiên', // 热度优先
  longVideoLobbyMoreCollect: 'Yêu thích nhất', // 最多收藏

  // 搜索短视频
  // longVideoLobbySearch: 'Vui lòng nhập từ khóa để tìm nguồn', // 请输入关键词查找片源
  // longVideoLobbySearchBtn: 'Tìm kiếm' // 搜索
  shortSearchNodata: 'Không có dữ liệu tìm kiếm', // 暂无搜索记录
  shortSearchAllHistory: 'Tất cả các dữ liệu tìm kiếm', // 全部搜索记录
  shortSearchClearAllHistory: 'Xóa tất cả dữ liệu tìm kiếm', // 清除全部搜索记录
  shortSearchHotList: 'Danh sách video ngắn hot', // 短视频热榜

  // 影片详情
  videoDetailVipTitle1: 'Phim này có nội dung dành riêng cho thành viên VIP', // 本片是VIP会员专享内容
  videoDetailVipTitle2: 'Vui lòng cho phép thành viên VIP xem', // 请开通VIP会员观看
  videoDetailVipTitle3: 'Kích hoạt thành viên VIP', // 开通VIP会员
  videoDetailBrief: 'Giới thiệu', // 简介
  videoDetailShare: 'Chia sẻ', // 分享
  videoDetailContent: 'Tình tiết', // 剧情
  videoDetailRecommend: 'Đề xuất cho bạn', // 为您推荐
  videoDetailCountDown: 'Đóng quảng cáo sau {countDownTime} giây', // 5秒后关闭广告
  videoDetailCloseAd: 'Đóng quảng cáo', // 关闭广告

  // 个人中心
  // 关注和粉丝列表
  mineFollowing: 'Theo dõi', // 关注
  mineFollower: 'Người theo dõi', // 粉丝
  mineFollowed: 'Đã theo dõi', // 已关注
  mineFollowMyself: 'Theo dõi mình', // 自己
  mineFollowEach: 'Theo dõi nhau', // 互相关注
  mineFollowBack: 'Hủy theo dõi', // 回关
  mineFollowCancel: 'Hủy theo dõi', // 取消关注
  mineFollowHim: 'Của anh/Cô ấy ', // 他的/她的
  mineFollowMe: 'Của tôi ', // 我的
  mineFollowPerson: '', // 人 （越南语为空）
  memberCard: 'Thẻ hội viên',
  wallet: 'Ví',
  shareInvitation: 'Chia sẻ lời mời',
  promotionMoney: 'Kiếm tiền qua quảng bá',
  fanGroup: 'Nhóm người hâm mộ',
  drivingGroup: 'Tham gia nhóm lái xe',
  createCenter: 'Trung tâm sáng tạo',
  community: 'Bài viết cộng đồng',
  myBuy: 'Mua hàng của tôi',
  gold: 'Xu vàng',

  // vip中心
  vipCenter: 'Trung tâm VIP',
  // 观看历史
  historyTitle: 'Lịch sử xem', // 观看历史
  maxGift: 'Tặng tối đa {money} xu',
  freeForeverWatch: 'Xem miễn phí vĩnh viễn video VIP không bản quyền',
  dayFreeWatch: 'Xem miễn phí {day} ngày mỗi ngày video VIP',
  videoPayFreeWatch: 'Xem miễn phí {num} video trả phí bằng xu mỗi ngày',
  carGroup: 'Mở khóa nhóm lái xe toàn quốc',
  welfareGroup: 'Mở khóa nhóm lợi ích bí mật',
  routeMovie: 'Tuyến đường xem phim HD độc quyền, phát siêu nhanh',
  paymentMsg: 'Nhắc nhở thanh toán',
  payNow: 'Thanh toán ngay',

  // 设置
  settingSafeTitle: 'Tài khoản và Bảo mật', // 账号与安全
  settingSafeAvatar: 'Ảnh đại diện', // 头像
  settingSafeUserName: 'Tên người dùng', // 用户名
  settingSafeNickName: 'Nickname', // 昵称
  settingSafeInviteCode: 'Mã mời', // 邀请码
  settingSafeEditPsd: 'Thay đổi mật khẩu đăng nhập', // 修改登录密码
  settingSafeUploadAvatar: 'Tải lên ảnh đại diện', // 上传头像
  settingSafeUpload: 'Tải lên', // 上传
  settingSafeChoosePic: 'Vui lòng chọn ảnh！', // 请选择图片！
  settingSafeUploadFailed: 'Tải lên không thành công', // 上传失败

  // 修改登录密码
  settingTitle: 'Cài đặt', // 设置
  settingChangeLang: 'Chuyển đổi ngôn ngữ', // 语言切换
  settingUpdateLoginPsd: 'Thay đổi mật khẩu đăng nhập', // 修改登录密码
  settingGetVerifyCode: 'Lấy mã xác minh', // 获取验证码
  settingUpdateLoginCheckNewPsd: 'Xác nhận mật khẩu đăng nhập mới', // 确认新的登录密码
  settingUpdateLoginNewPsd: 'Vui lòng nhập mật khẩu đăng nhập mới', // 请输入新的登录密码
  settingUpdateFailed: 'Thay đổi không thành công', // 修改失败
  settingUpdateByPhone: 'Thay đổi mật khẩu đăng nhập bằng số điện thoại di động', // 通过手机号修改登录密码
  settingUpdateByEmail: 'Thay đổi mật khẩu đăng nhập bằng Email', // 通过邮箱号修改登录密码

  // 任务中心
  taskTitle: 'Trung tâm tác vụ', // 任务中心
  taskDaily: 'Tác vụ mỗi ngày', // 每日任务
  taskFinished: 'Hoàn thành', // 已完成
  taskGo: 'Hoàn thành ngay', // 去完成

  // 修改用户资料
  userInfoEditBg: 'Thay đổi hình nền', // 更换背景
  userInfoEditProcess: 'Sự hoàn chỉnh', // 资料完成度
  userInfoEditAvatar: 'Click để thay đổi ảnh đại diện', // 点击更换头像
  userInfoEditMale: 'Nam', // 男
  userInfoEditFemale: 'Nữ', // 女
  userInfoEditPrivate: 'Bảo mật', // 保密
  userInfoEditNickName: 'Nickname', // 昵称
  userInfoEditUpdateNickName: 'Thay đổi nickname', // 设置昵称
  userInfoEditSetNickName: 'Cài đặt nickname', // 设置昵称
  userInfoEditBrief: 'Giới thiệu', // 简介
  userInfoEditIntroduce: 'Giới thiệu bản thân', // 介绍一下自己
  userInfoEditFullInfo: 'Thêm + 10% để hoàn thành thông tin', // 完善信息加+10%
  userInfoEditGender: 'Giới tính', // 性别
  userInfoEditChoseGender: 'Lựa chọn giới tính', // 选择性别
  userInfoEditBirthday: 'Sinh nhật', // 生日
  userInfoEditChooseBirthday: 'Lựa chọn sinh nhật', // 选择生日
  userInfoEditAddress1: 'Địa điểm', // 所在地
  userInfoEditAddress2: 'Bạn ở đâu', // 你在哪儿
  userInfoEditPhone: 'Điện thoại', // 手机号
  userInfoEditPhone1: 'Điền vào điện thoại', // 填写你的手机号
  userInfoEditEmail: 'Thư', // 邮箱
  userInfoEditEmail1: 'Điền vào số email của bạn', // 填写你的邮箱号
  userInfoEditInviteCode: 'Mã mời', // 邀请码
  userInfoEditUploadBg: 'Tải lên hình nền', // 上传背景图
  userInfoEditToday: 'Hôm nay', // 今天
  userInfoEditSave: 'Lưu', // 保存
  userInfoEditMyNickName: 'Nickname của bạn', // 我的昵称
  userInfoEditAddress3: 'Khu vực', // 所在地区
  userInfoEditAddress4: 'Địa chỉ', // 地址
  userInfoEditUpdate: 'Thay đổi', // 修改
  userInfoEditSet: 'Cài đặt', // 设置
  userInfoVipTime: 'Thành viên VIP cho', // VIP会员至

  // 用户中心
  userDetailIntro: 'Click thêm giới thiệu, để mọi người làm quen bạn', // 点击添加介绍，让大家认识你
  userDetailLogout: 'Đăng xuất', // 退出登录
  userDetailGetLike: 'Thích', // 获赞
  userDetailWork: 'Sản phẩm', // 作品
  userDetailPrivate: 'Riêng tư', // 私密
  userDetailLike: 'Thích', // 喜欢
  userDetailCollect: 'Sưu tầm', // 收藏
  userDetailLogoutFailed: 'Đăng xuất không thành công', // 退出失败
  userDetailDepositCenter: 'Trung tâm nạp tiền', // 充值中心
  userDetailEditInfo: 'ật chất', // 编辑资料
  userDetailAddFriend: 'hêm bạn', // 添加好友
  userDetailMessage: 'Thư riêng', // 私信

  // 评论组件
  commentCount: 'dòng bình luận', // xxx条评论
  commentPlaceholder: 'Cùng nhau nói điều gì đó nhé～', // 来一起说点什么吧～
  commentSend: 'Gửi', // 发送
  commentContent: 'Vui lòng nhập nội dung bình luận', // 请输入评论内容

  // 我的钱包
  myWallet: 'Túi của tôi', // 我的钱包
  myBalance: 'Tổng tài sản', // 总资产
  myAToken: 'ANTG', // A币
  myIncome: 'Thu nhập của tôi', // 我的收益
  myReceiptWay: 'Nhận tiền', // 收款方式
  myWithdraw: 'Rút', // 提现
  myBills: 'Hóa đơn', // 账单
  questionsTitle: 'Vấn đề thường gặp', // 常见问题
  whatIsATitle: '1. A coin là gì?', // 1、A币是什么？
  whatIsATips1: 'Đồng xu là sự tích hợp các quỹ trong nền tảng {siteTitle}. Các phong bì màu đỏ nhận được qua trò chuyện trực tiếp và thu nhập kiếm được có thể được gửi vào tiền lẻ, hỗ trợ tiêu dùng, phong bì đỏ, phần thưởng, rút tiền mặt và các chức năng khác.', // 余额是在蚂蚁视频支付中的资金，聊天直播收到的红包、赚取的收入可以存入零钱、支持消费，红包，打赏，提现等功能
  whatIsATips2: 'Đơn vị tiền tệ và quy đổi RMB 1: 1', // A币和人民币1:1换算
  whatIsATips3: 'Chuyển đổi tỷ giá hối đoái theo thời gian thực và tiền tệ Tether', // A币和泰达币（火币网实时汇率）换算
  whatIsATips4: 'Chuyển đổi tỷ giá hối đoái theo thời gian thực của tiền tệ và đồng Việt Nam', // A币和越南盾根据公司实时汇率换算
  whatIsIncomeTitle: '2. Quyền lợi của tôi là gì?', // 2、我的收益是什么？
  whatIsIncomeTips1: 'Thu nhập của tôi là A coin bạn nhận được sau khi hoàn thành nhiệm vụ đăng nhập, hoàn thành hoạt động và đạt được mục tiêu thăng hạng, đồng thời hỗ trợ các chức năng như tiêu dùng, phong bao đỏ, phần thưởng và rút tiền mặt.', // 我的收益实在你完成签到任务，完成活动，达到推广指标后获得的A币，支持消费，红包，打赏，提现等功能。
  payWaysTitle: '3. Những phương thức thanh toán nào được hỗ trợ?', // 2、我的收益是什么？
  payWaysTips1: 'Nếu bạn là người dùng đại lục, thì chúng tôi sẽ cung cấp các phương thức rút tiền như thẻ ngân hàng / WeChat / Alipay / Tether;', // 如果您是大陆用户，那么我们将会提供银行卡/微信/支付宝/泰达币等提现方式；
  payWaysTips2: 'Nếu bạn là người dùng Việt Nam, thì chúng tôi sẽ cung cấp các phương thức rút tiền như Gcash / Vietnam Bank / vsira / Tether;', // 如过您是越南用户，那么我们将会提供Gcash/越南银行/vsira/泰达币等提现方式；
  payWaysTips3: 'Nếu bạn là người dùng châu Âu và Mỹ, thì chúng tôi sẽ cung cấp phương thức rút tiền bằng Tether;', // 如果您是欧美用户，那么我们将会提供泰达币提现方式；
  payWaysTips4: 'Nhấp vào phương thức thanh toán để vào trang ràng buộc phương thức thanh toán tương ứng, khi rút tiền hãy chọn phương thức này để rút.', // 点击收款方式进入页面绑定对应的收款方式在提现时选择该方式提现即可。

  // 充值中心
  depositAToken: 'Nạp tiền A', // 充值A币
  depositVip: 'Thành viên', // 充值会员
  depositChannel: 'Kênh sưu tập', // 收款通道
  depositOfflineInfo: 'Tin nhắn thanh toán', // 收款信息
  depositCurrencyName: 'Tên tiền tệ', // 货币名称
  depositCurrencyLink: 'Liên kết tiền tệ', // 货币链路
  depositCurrencyAddress: 'địa chỉ tiền tệ', // 货币地址
  depositPayerAddress: 'địa chỉ người chuyển tiền', // 汇款人地址
  depositPayerAddressHint: 'Vui lòng nhập địa chỉ của người gửi', // 请输入汇款人地址
  depositAmount: 'Số tiền đặt cọc', // 存款金额
  depositChooseAmount: 'Vui lòng chọn một số tiền', // 请选择金额
  depositInputAmount: 'Vui lòng nhập số tiền', // 请输入金额
  depositTipsMin: 'Lưu ý: Số tiền nạp tối thiểu là {min} {unit} dân tệ;', // 注：最小充值xx元；最大充值xx元
  depositTipsMax: 'Số tiền nạp tối đa là {max} {unit} dân tệ', // 注：最小充值xx元；最大充值xx元
  depositSubmit: 'Xác nhận gửi', // 确定提交
  depositNoChannel: 'Không có kênh thanh toán ~', // 暂无收款通道~
  depositPayFailed: 'Thanh toán không thành công', // 支付失败
  depositDay: 'Ngày', // 天
  depositPleaseChoose: 'Vui lòng chọn', // 请选择

  // 收款方式
  withdrawalWays: 'phương thức thanh toán', // 收款方式
  withdrawalAlipayName: 'Alipay tên', // 支付宝姓名
  withdrawalAlipayAccount: 'Tài khoản alipay', // 支付宝账号
  withdrawalShowAlipayAccount: 'Hiển thị tài khoản Alipay', // 显示支付宝账号
  withdrawalCheckQrcode: 'Xem mã QR', // 查看二维码
  withdrawalWechatName: 'Tên WeChat', // 微信名称
  withdrawalUsername: 'tên tài khoản', // 用户姓名
  withdrawalBankAccount: 'Số thẻ ngân hàng', // 银行卡号
  withdrawalShowBankAccount: 'Hiển thị số thẻ ngân hàng', // 显示银行卡号
  withdrawalBankName: 'Tên ngân hàng', // 银行名称
  withdrawalWalletName: 'Tên ví', // 钱包名称
  withdrawalWalletAddress: 'địa chỉ ví', // 钱包地址
  withdrawalTokenName: 'Tên tiền tệ', // 币种名称
  withdrawalTokenLink: 'Tên liên kết', // 链路名称
  withdrawalAddress: 'Địa chỉ thanh toán', // 收款地址
  withdrawalAdd: 'Thêm một Phương thức thanh toán', // 添加收款方式
  withdrawalClose: 'Khép kín', // Khép kín
  withdrawalAll: 'Nguyên', // 全部

  // 修改收款方式
  withdrawalWaysChoose: 'Vui lòng chọn một phương thức thanh toán', // 请选择收款方式
  withdrawalWaysNo: 'Chưa có phương thức thanh toán', // 暂无收款方式
  withdrawalWaysInputInfo: 'Điền thông tin', // 填充信息
  withdrawalWaysWechatAccount: 'Wechat ID', // 微信号
  withdrawalWaysUploadQrcode: 'Tải lên mã thanh toán', // 上传收款码
  withdrawalWaysUploadMyQrcode: 'Tải lên mã thanh toán của tôi', // 上传我的收款码
  withdrawalWaysPassword: 'Mật khẩu rút tiền', // 取款密码
  withdrawalWaysInputWechatName: 'Vui lòng nhập tên WeChat', // 请输入微信名称
  withdrawalWaysInputAlipayName: 'Vui lòng nhập tên Alipay', // 请输入支付宝姓名
  withdrawalWaysInputUserName: 'Vui lòng nhập tên người dùng', // 请输入用户姓名
  withdrawalWaysInputWechatAccount: 'Vui lòng nhập ID WeChat', // 请输入微信号
  withdrawalWaysInputAlipayAccount: 'Vui lòng nhập tài khoản Alipay của bạn', // 请输入支付宝账号
  withdrawalWaysInputBankAccount: 'Vui lòng nhập số thẻ ngân hàng', // 请输入银行卡号
  withdrawalWaysInputBankName: 'Vui lòng nhập tên ngân hàng', // 请输入银行名称
  withdrawalWaysInputWalletAddress: 'Vui lòng nhập địa chỉ ví', // 请输入钱包地址
  withdrawalWaysInputAddress: 'Vui lòng nhập địa chỉ thanh toán', // 请输入收款地址
  withdrawalWaysInputPassword: 'Vui lòng nhập mật khẩu rút tiền', // 请输入取款密码
  withdrawalWaysModify: 'Ôn lại', // 修改
  withdrawalWaysAdd: 'Thêm vào', // 添加
  withdrawalWaysTips: 'Nhắc nhở: Nếu bạn chưa đặt mật khẩu rút tiền, mật khẩu rút tiền bạn đã nhập sẽ được sử dụng làm mật khẩu rút tiền mặc định khi ràng buộc phương thức thanh toán lần đầu tiên.', // 温馨提示：如您没有设置取款密码，首次绑定收款方式时，您输入的取款密码将作为默认取款密码使用
  withdrawalWaysModifyFailed: 'Không thể chỉnh sửa', // 修改失败
  withdrawalWaysAddFailed: 'Thêm không thành công', // 添加失败

  // 提现
  withdrawal: 'Rút', // 提现
  withdrawalChooseWays: 'Vui lòng chọn phương thức rút tiền', // 请选择提现方式
  withdrawalAccount: 'Tài khoản rút tiền', // 提现账户
  withdrawalAmount: 'Số tiền rút', // 提现数量
  withdrawalInputAmount: 'Vui lòng nhập số tiền rút (ANTG)', // 请输入提现数量（ANTG）
  withdrawalBalance: 'Số dư có thể rút', // 可提现余额
  withdrawalTipsTitle: 'Hướng dẫn rút tiền', // 提现说明
  withdrawalTips1: 'Thời gian rút tiền: rút bất cứ lúc nào trong vòng 24 giờ', // 提现时间：24小时内随时提现
  withdrawalTips2: 'Giới hạn rút tiền một lần: từ 100 xu', // 单笔提现限额：100个币起
  withdrawalNoways: 'Bạn chưa ràng buộc thông tin thanh toán!', // 您还未绑定该收款信息！
  withdrawalFailed: 'Rút tiền không thành công', // 提现失败

  // 钱包设置
  walletSetting: 'Cài đặt', // 设置
  walletModifyWithDrawPsd: 'Sửa đổi mã rút tiền', // 修改取款码
  bindMobile: 'Vui lòng liên kết số điện thoại của bạn trước', // 请先绑定手机号

  // 修改取款码
  walletModifyWithDrawPsdByPhone: 'Sửa đổi mã rút tiền qua điện thoại di động', // 通过手机修改取款码
  walletModifyWithDrawPsdByEmail: 'Sửa đổi mã rút tiền qua email', // 通过邮箱修改取款码
  walletModifyWithDrawPsdConfirm: 'Xác nhận mật khẩu rút tiền mới', // 确认新的取款密码
  walletModifyWithDrawPsdInput: 'Vui lòng nhập mã rút tiền', // 请输入取款码

  // 账单
  billTitle: 'hóa đơn',
  billSelectTypeTitle: 'Chọn loại giao dịch',
  billAll: 'Nguyên',
  billTo: 'đến',
  // vip中心
  lookRules: 'Hiện quy tắc',
  vipRules: 'Nội quy thành viên',
  vipOrdinary: 'Thành viên bình thường',
  vipTimeTo: 'Thành viên VIP để',
  vipJoinNow: 'Tham gia VIP ngay bây giờ!',
  doDeposit: 'Nạp',
  vipPrivilege: 'Đặc quyền',
  vipDetail: 'Chi tiết',
  upMoney: 'Tiến tới xổ số',
  viewingTimes: 'Giờ xem',
  vipMovie: 'Hành động VIP',
  vipNovel: 'Cỡ VIP',
  vipCartoon: 'ảnh VIP',
  unlimitedViewing: 'Không giới hạn',
  pleaseWaiting: 'Sắp đến rồi.',
  moviePlayTimes: 'Số khung ảnh',
  movieLikeTimes: 'Phim thích',
  movieCommentTimes: 'Số lần xem phim',
  movieCollectTimes: 'Thu thập phim',
  shortVideoPlayTimes: 'Thời gian xem video ngắn',
  shortVideoAwesomeTimes: 'Số đoạn video ngắn thích',
  shortVideoCommentTimes: 'Số chú thích video ngắn',
  shortVideoShareTimes: 'Số lần chia sẻ video ngắn',
  shortVideoLikeTimes: 'Số lần thử lại:',
  adClickTimes: 'Vẽ biếm hoạ',
  // 签到中心
  signCenter: 'Ký vào giữa',
  signRules: 'Quy tắc đăng ký',
  memberSign: 'kí vào',
  continueSign: 'Tiếp tục kiểm tra',
  sign: 'Ký vô.',
  signIn: 'đăng nhập',
  signInfo: 'Ký vào thông tin',
  signTotalMoney: 'Định hướng kí tặng xổ số',
  signContinueDay: 'Biểu tượng liên tục trong ngày',
  signEndDate: 'Hết giờ hoạt động',
  signOrNot: 'Ký vào hay không',
  signSuccess: 'Đăng nhập thành công',

  //  下载页
  downloadTitle: 'Gặp gỡ kỷ nguyên nhà ga {siteTitle} tiếp theo', // 遇见下一个Titok站时代
  downloadBtn: 'Tải xuống APP', // 下载APP
  downloadAndroid: 'Tải xuống Android', // 下载Android
  downloadIos: 'Tải xuống Ios', // 下载Ios
  // 他人主页
  shareHomepage: 'Dăng lại', // 分享主页

  novelAddToShell: 'Thêm vào',
  novelAddedToShell: 'Đã thêm ',
  novelPerson: '{0} người',
  novelReadCount: 'mức độ phổ biến tích lũy',
  novelReadNow: 'đọc ngay bây giờ',
  novelHot: 'Tiểu thuyết hay',
  novelChapterNumber: 'Chương {0}',
  novelIndex: 'Mục lục',
  novelLastChapter: 'Trang tiếp',
  novelNextChapter: ' Trang trước',
  novelChapterCount: 'Tổng số {0} chương',
  novelSortUp: 'Đặt hàng',
  novelSortDown: 'đảo ngược thứ tự',
  novelMyShell: 'Giá sách của tôi',
  novelClass: 'phân loại',
  novelNum: '{0} cuốn tiểu thuyết',
  novelEnterBook: 'Vui lòng nhập tên sách',
  novelHistory: 'Lịch sử đọc',
  novelSearchHistory: 'Lịch sử Tìm kiếm',
  novelAlreadyInShell: 'Đã thêm vào giá sách',
  novelNoVipTips: 'Bạn chưa phải là VIP, hãy nạp tiền ngay bây giờ',
  novelSearchDiscover: 'Tìm kiếm khám phá',
  novelSort: 'phân loại',
  novelRank: 'xếp hạng',
  novelSerial: 'Nối tiếp',
  novelFree: 'Miễn phí',
  novelDone: 'Miễn phí ',
  novelCollect: 'đã được thêm vào giá sách',
  novelUnCollect: 'đã bị xóa khỏi giá sách',
  novelChoice: 'Lựa chọn bán chạy nhất',

  // 维护
  maintenanceTitle: 'Hệ Thống Bảo Trì', // 系统维护
  maintenanceTime: 'Thời Gian Bảo Trì', // 维护时间

  // im

  message: 'tin nhắn',
  privateMessage: 'Mật Tín',
  followBack: 'Quay lại',
  setAlias: 'Đặt Ghi chú',
  newFriend: 'Bạn Mới',
  stickToTop: 'trò chuyện dính',
  addToBlacklist: 'kéo màu đen',
  friend: 'người bạn',
  silent: 'im lặng',
  sendMessage: 'Gửi tin nhắn',
  allEmoji: 'Tất cả các biểu thức',
  deleteFriend: 'Xóa bạn bè',
  unfollow: 'bỏ theo dõi',
  enterAlias: 'Nhập nhận xét',
  follow: 'theo dõi',
  addUser: 'Thêm người dùng',
  remove: 'Xóa',
  search: 'tìm kiếm',
  followYou: 'đã theo dõi bạn',
  cancelSilent: 'Hủy hủy không làm phiền',
  setTop: 'Hàng đầu',
  cancelSetTop: 'hủy set top',
  justNow: 'ngay bây giờ',
  minuteAgo: '{0} phút trước',
  hourAgoe: '{0} giờ trước',
  dayAgo: '{0} ngày trước',
  youAreNotFriend: 'Bạn không phải là bạn của bên kia, bạn có thể tiếp tục gửi tin nhắn sau khi bên kia trả lời bạn',
  yourBlockHim: 'Bạn đã chặn bên kia, vui lòng tiếp tục gửi tin nhắn sau khi bỏ chặn',
  yourAreBlock: 'Do cài đặt quyền riêng tư của bên kia, TA không thể nhận tin nhắn của bạn',
  audioTooShort: 'Thời gian ghi âm quá ngắn',
  notSupportRecord: 'Thiết bị không hỗ trợ ghi âm',
  holdToTalk: 'Giữ để nói',
  releaseSend: 'Đi để gửi, trượt lên để hủy',
  releaseCancel: 'Buông để hủy',
  whoFollowedYou: '{0} vừa theo dõi bạn',
  whoSendYouMessage: 'Đã nhận {0} tin nhắn mới',
  delete: 'xóa bỏ',
  shareFailed: 'Chia Sẻ Không Thành Công',
  shareSucceed: 'Chia sẻ thành công',
  shareMovie: 'Chia Sẻ Video',
  shareShortVideo: 'Chia Sẻ Video Ngắn',
  shareNovel: 'Chia Sẻ Tiểu Thuyết',
  shareToFriend: 'Chia sẻ cho bạn bè',
  noFriends: 'Chưa có bạn',
  conversationWarning: 'Bởi vì bạn không theo dõi nhau, bạn chỉ có thể gửi một tin nhắn trước khi nhận được trả lời',
  toFollowSomeOne: 'Chưa có bạn nào theo dõi bạn, hãy theo dõi người khác~',

  restPasswordEnterNewRePsd: 'Vui lòng nhập lại mật khẩu mới',
  phoneLogin: 'Đăng nhập số điện thoại di động',
  accountLogin: 'đăng nhập tài khoản',
  noAccount: 'Chưa có tài khoản',
  goRegister: 'Đi tới đăng ký',
  accountPasswordRegister: 'đăng ký mật khẩu tài khoản',
  phoneRegister: 'Đăng ký số điện thoại di động',
  loginGetCode: 'Lấy Mã Xác Nhận',
  resetWarning: 'Không thể đặt lại mật khẩu nếu không có số điện thoại di động hoặc địa chỉ email',
  phoneReset: 'Số điện thoại di động đã lấy',
  emailReset: 'Đặt lại email',
  reGetVerifyCode: 'Gửi lại mã xác minh',
  lastMsgEffect: 'Mã xác minh hợp lệ trong vòng năm phút',
  restPasswordNotEquale: 'Hai mật khẩu không nhất quán',

  commentReply: 'Trả lời',
  commentClickLoadMore: 'Nhấp để xem thêm',
  commentExpandMore: 'Mở rộng thêm câu trả lời',
  commentCollapse: 'Thu gọn',
  commentEnterTextOrImage: 'Vui lòng nhập nhận xét hoặc hình ảnh',
  commentAllMsg: 'Tất cả tin nhắn',
  commentMentionMe: '@My',
  commentGetReply: 'Nhận xét',
  commentReplySuccess: 'Trả lời thành công',
  commentMentionYou: 'Đã đề cập đến bạn',
  commentYou: 'Đã bình luận cho bạn',
  commentReplyYou: 'đã trả lời bạn',
  commentInteraction: 'tin nhắn tương tác',
  commentHaveDeleted: 'bình luận đã bị xóa',
  commentConfirmDelete: 'Bạn có chắc chắn muốn xóa bình luận này? ',
  commentNoMsg: 'Chưa có tin nhắn tương tác',

  // 社区
  newest: 'Mới nhất',
  marrow: 'Tinh hoa',
  communityVideo: 'Video',
  scan: 'Duyệt',
  like: 'Thích',
  comment: 'Bình luận',
  postsDetail: 'Chi tiết bài viết',
  choseTopic: 'Chọn chủ đề',
  publishMoney: 'Mở khóa xu (tối đa 99 xu)',
  // publishTitle: 'Nhập tiêu đề',
  publishTitlePlaceholder: 'Nhập tiêu đề phù hợp với nội dung video',
  publishContent: 'Nhập nội dung',
  publishContentPlaceholder: 'Viết một số nội dung ở đây',
  publicImg: 'Tải lên hình ảnh',
  publicVideo: 'Tải lên video',
  publicVideoTips: 'Tối đa 100M',
  publicImgTips: 'Tối đa 1M mỗi hình ảnh',
  buyPosts: 'Mua bài viết',
  buyPostsTips: 'Mở khóa để xem toàn bộ nội dung',
  buyPostsTips1: 'Xem trước kết thúc, cần {0} xu để mua',
  buyMoneys: 'Số dư tài khoản không đủ {0} xu, vui lòng nạp xu',
  buyMoney: 'Số dư tài khoản không đủ, vui lòng nạp xu',
  buyVip: 'Vui lòng mua VIP',
  RechargeMoney: 'Nạp xu',
  previewOver: 'Xem trước kết thúc,',
  limitScanVideo: 'Xem trước {0} giây, {1} xu để xem toàn bộ video',
  //  邀请分享
  inviteUserWatchTip: 'Mời một người dùng là có thể xem không giới hạn trong 5 ngày',
  inviteUserRateTip: 'Người dùng được mời nạp tiền hoàn 40',
  adultVideos: 'Video ngắn người lớn',
  codeScan: 'Quét mã QR',
  downAppWatch: 'Tải APP để xem ngay',
  yourInviteCode: 'Mã mời của bạn',
  downQrCode: 'Tải mã QR',
  copyLinkShare: 'Sao chép liên kết chia sẻ',

  //  邀请记录
  inviteRecord: 'Lịch sử mời',
  invitedFriendLoginSuccess: 'Bạn bè được mời phải đăng nhập mới được tính là mời thành công',

  //  推广代理
  promotion: 'Đại lý quảng bá',
  activityContent: 'Nội dung hoạt động',
  performanceTotal: 'Tổng thành tích',
  detailsRevenue: 'Chi tiết doanh thu',
  revenueTotal: 'Tổng doanh thu',
  opportunitySeize: 'Nắm bắt cơ hội',
  wealthFreedom: 'Đạt được tự do tài chính bằng hành động',
  inviteSuccessfullyRechargeUser: 'Mời thành công 1 người dùng nạp tiền và nhận ngay {0}% hoàn tiền',
  nowPromote: 'Tiến hành quảng bá ngay',
  richClose: 'Giàu có chỉ còn trong tầm tay',
  promotionChannel: 'Nếu bạn có kênh quảng bá và muốn kiếm tiền, trở thành đại lý chính thức',
  percentageProportion: 'Chia hoa hồng lên đến 80%, thu nhập 100K mỗi tháng không còn là mơ',
  serviceContact: 'Liên hệ dịch vụ khách hàng',
  promoteHow: 'Cách quảng bá',
  inviteSuccessfullyVipUser: 'Mời một người có thể nhận 3 ngày VIP, có thể cộng dồn vô hạn～',
  stepOne: 'Bước một',
  stepTwo: 'Bước hai',
  stepThree: 'Bước ba',
  clickSave: 'Nhấp vào【Lưu ảnh】hoặc【Sao chép liên kết】',
  sendInfo: 'Gửi ảnh hoặc liên kết qua các kênh khác nhau',
  exampleOne: 'Như các ứng dụng mạng xã hội phổ biến',
  exampleTwo: 'Như các ứng dụng game phổ biến',
  inviteDownloadAward: 'Người được mời tải ứng dụng và tự động liên kết, người mời nạp tiền sẽ nhận ngay hoàn tiền (có thể rút tiền)',

  //  我加入的粉丝团
  fansGroup: 'Nhóm người hâm mộ',
  fanClubNumber: 'Số lượng thành viên câu lạc bộ fan',
  joinedDay: 'Đã gia nhập {day} ngày',

  //  创作者中心
  searchVideo: 'Tìm kiếm video/thẻ/người dùng',
  workManage: 'Quản lý tác phẩm',
  published: 'Đã phát hành',
  reviewPending: 'Chờ duyệt',
  fansExclusive: 'Dành riêng cho fan',
  greatGods: 'Thần Vĩ Đại',
  haveNumPeople: 'Đã có {num} người',
  becomeCreator: 'Trở thành người sáng tạo 18Porn',
  makeMoneyNow: 'Kiếm tiền ngay',
  createdYourselfFanGroup: 'Tạo câu lạc bộ fan của riêng bạn',
  createFanGroup: 'Tạo câu lạc bộ fan',
  creationStrategy: 'Chiến lược sáng tạo',

  //  创建粉丝团
  fanClubName: 'Tên Câu Lạc Bộ',
  fanClubNamePlaceholder: 'Nhập tối đa 10 ký tự',
  fanClubNameMsg: 'Nhập tên câu lạc bộ',
  fanClubIntroduction: 'Giới thiệu CLB',
  fanClubIntroductionMsg: 'Nhập giới thiệu',
  fanClubMonth: 'Thẻ Tháng',
  fanClubMonthMsg: 'Nhập thẻ tháng',
  fanClubSeason: 'Thẻ Mùa',
  fanClubSeasonMsg: 'Nhập thẻ mùa',
  fanClubYear: 'Thẻ Năm',
  fanClubYearMsg: 'Nhập thẻ năm',
  ticketPlaceholder: 'Đặt > 30 xu',

  //  排行榜
  ranking: 'Bảng xếp hạng',
  richRanking: 'Danh sách giàu có',
  originalWorkRanking: 'Tác phẩm gốc',
  originalPopularityRanking: 'Sự phổ biến gốc',
  originalLikeRanking: 'Lượt thích gốc'
};
